<template>
  <div>
    <div class="back" @click="$router.back()">
      <img class="back-image" src="@/assets/img/icon_back.png" alt="" />
      <span class="back-text">返回上一页</span>
    </div>
    <div class="content" @click="toUrl()">
      <div class="title">
        {{ details.title }}
      </div>
      <div class="time">
        {{ $Tools.time(details.publishDate, "yyyy-MM-dd hh:mm:ss") }}
      </div>
      <div class="text" v-html="details.content"></div>
    </div>
  </div>
</template>

<script>
import page_mx from "@/mixin/page_mx";
export default {
  mixins: [page_mx],
  data() {
    return {};
  },
  methods: {
    // 初始化
    async init() {
      this.getArticleDetail(this.$route.query.id);
    },
    toUrl() {
      if (
        this.details.contentType === "超链接" ||
        this.details.contentType === "视频"
      ) {
        window.open(this.details.url, "_blank");
      }
    },
  },
};
</script>
<style lang="less" scope>
.back {
  width: 1160px;
  margin: 30px auto 0;
  display: flex;
  align-items: center;
  cursor: pointer;
  &-image {
    vertical-align: middle;
  }
  &-text {
    font-size: 16px;
    color: #666;
  }
}
.content {
  width: 640px;
  margin: 30px auto 0;
  text-align: center;
  cursor: pointer;
  .title {
    font-size: 32px;
    font-weight: 600;
    color: #333333;
  }
  .time {
    margin-top: 20px;
    font-size: 14px;
    color: #666;
  }
  .text {
    margin: 30px 0;
    text-align: center;
    font-size: 16px;
    color: #333;
  }
}
</style>
